import { useMemo, useCallback } from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import { isDateInThePast } from '../utils/DateUtils'


const useConfiguration = () => {
  const query = useStaticQuery(graphql`
    query configuration {
      contentfulConfiguration {
        ...balenciageF21Configuration
      }
    }
  `)

  const isDateElapsed = useCallback((date) => isDateInThePast(date, new Date()), [])
  const isWebsiteClosed = useMemo(() => query?.contentfulConfiguration?.siteOffline, [query])
  const isGameClosed = useMemo(() => query?.contentfulConfiguration?.gameOffline, [query])
  const seoFallback = useMemo(() => query?.contentfulConfiguration?.seo, [query])

  return { configuration: query?.contentfulConfiguration ?? {}, isDateElapsed, isWebsiteClosed, isGameClosed, seoFallback }
}

export default useConfiguration
